export default function stringToBool(str) {
  if (str === null || str === undefined) return false; // 处理 null/undefined
  if (typeof str === 'string') {
    str = str.trim().toLowerCase(); // 忽略大小写和空格
    if (str === 'null' || str === 'false' || str === '0' || str === '') {
      return false;
    }
  }
  return Boolean(str); // 其他情况按默认规则转换
}
